module.exports = __webpack_public_path__ + "static/img/davis_pictgrid33_920x847.74b9fde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid33_920x847.jpg
// module id = JDF0
// module chunks = 0